import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getData } from "../../apis";
import { API } from "../../apis/config";
import LoadingScreen from "../../components/LoadingScreen";
import { Notices } from "../../components/Notices";
import { Notice } from "../../interfaces/Notice";

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const [noticeList, setNoticeList] = useState<Notice[]>([]);

  useEffect(() => {
    const data = async () => {
      var response = await getData<Notice[]>(API.FESTA_STAFF.NOTICES);
      setNoticeList(response.result);
    };
    data().finally(() => setIsLoading(false));
  }, [dispatch]);
  // const lastNotice = noticeList.at(noticeList.length - 1);
  // const displayLastNotice = () => {
  //   return lastNotice?.content.split("\n\r").map((v1, i1) => {
  //     return v1.split("\n").map((v2, i2) => {
  //       if ((i1 !== 0 && i2 === 1) || (i1 === 0 && i2 === 0)) {
  //         return (
  //           <div key={i2}>
  //             <br />
  //             <div className="text-left font-semibold">{v2}</div>
  //           </div>
  //         );
  //       } else {
  //         return (
  //           <div key={i2} className="text-left mx-5">
  //             {v2}
  //           </div>
  //         );
  //       }
  //     });
  //   });
  // };
  return (
    <div>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <div className="whitespace-pre-wrap place-self-center w-full md:w-1/2">
          {/* <div className="text-2xl font-bold">{lastNotice?.title}</div>
          {displayLastNotice()} */}
          <Notices noticeList={noticeList} />
        </div>
      )}
    </div>
  );
}
